import { AttachmentRespType } from '../models'

export type PreparedAttachmentFile = {
  file: File | null
  errorMessage: string | null
}

export type AttachmentUploadFailure = {
  fileName: string
  errorMessage: string
}

type UploadAttachmentsSequentiallyOptions = {
  prepareFile: (file: File) => Promise<PreparedAttachmentFile>
  uploadFile: (file: File) => Promise<AttachmentRespType>
  onUploaded: (attachment: AttachmentRespType) => void
  uploadErrorMessage: (reason: unknown) => string
  fallbackPreparationErrorMessage: string
}

export async function uploadAttachmentsSequentially(
  files: File[],
  options: UploadAttachmentsSequentiallyOptions
): Promise<AttachmentUploadFailure[]> {
  const failures: AttachmentUploadFailure[] = []

  for (const file of files) {
    try {
      const preparedFile = await options.prepareFile(file)
      if (preparedFile.file == null) {
        failures.push({
          fileName: file.name,
          errorMessage:
            preparedFile.errorMessage ?? options.fallbackPreparationErrorMessage,
        })
        continue
      }

      const uploadedAttachment = await options.uploadFile(preparedFile.file)
      options.onUploaded(uploadedAttachment)
    } catch (reason) {
      failures.push({
        fileName: file.name,
        errorMessage: options.uploadErrorMessage(reason),
      })
    }
  }

  return failures
}
